import {
    GAMIFICATION_ECONOMY_MESSAGE,
    SENIOR_MARKETING_SALARY_HOUR_MULTIPLIER,
} from './gamification-economies.constants';

const pluralize = (value, singular) => `${value} ${value === 1 ? singular : `${singular}s`}`;
const pluralizeTrunc = (value, singular) => pluralize(Math.floor(value), singular);

const HOURS_PER_DAY = 8;
const DAYS_PER_WEEK = 5;
const WEEK_PER_MONTH = 4.4;
const MONTH_PER_YEAR = 12;
const HOURS_PER_WEEK = HOURS_PER_DAY * DAYS_PER_WEEK;
const HOURS_PER_MONTH = HOURS_PER_WEEK * WEEK_PER_MONTH;
const HOURS_PER_YEAR = HOURS_PER_MONTH * MONTH_PER_YEAR;

const getRelativeTime = (value) => {
    if (value < HOURS_PER_DAY) return pluralizeTrunc(value, 'hour');
    if (value < HOURS_PER_WEEK) return pluralizeTrunc(value / HOURS_PER_DAY, 'day');
    if (value < HOURS_PER_MONTH) return pluralizeTrunc(value / HOURS_PER_WEEK, 'week');
    if (value < HOURS_PER_YEAR) return pluralizeTrunc(value / HOURS_PER_MONTH, 'month');
    return pluralizeTrunc(value / HOURS_PER_YEAR, 'year');
};

export const getEconomyMessage = (boardData) => {
    const report = boardData.find(entry => entry.economyType === 'man_hour');
    const relativeTime = getRelativeTime(report.economyValue);
    const spent = SENIOR_MARKETING_SALARY_HOUR_MULTIPLIER * report.economyValue;

    const formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'BRL' });
    const formattedSpent = formatter.format(spent);

    const props = { relativeTime, formattedSpent };

    return GAMIFICATION_ECONOMY_MESSAGE
        .replace(/:([a-zA-Z]+)/g, (_, name) => props[name]);
};
